module.exports = __webpack_public_path__ + "static/hero-hr-blog-bc1743e2a39a09d433dbaede5ade0927.png";